import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {AbstractVisbosComponent} from "../../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../../shared/actions/session.actions";
import {FormBuilder, FormControl} from "@angular/forms";
import {MessageType} from "../../../../shared/redux-store/session/session.types";
import {MoveStocksListComponent} from "../../components/move-stocks-list/move-stocks-list.component";
import {FileService} from "../../../../core/visbos-core/http/file.service";
import {StockService} from "../../../services/stock.service";

@Component({
  selector: 'vb-move-stocks-view',
  templateUrl: './move-stocks-view.component.html',
  styleUrls: ['./move-stocks-view.component.css']
})
export class MoveStocksViewComponent extends AbstractVisbosComponent implements OnInit {

  @ViewChild('moveStocksList')
  moveStocksList: MoveStocksListComponent;

  searchTerm: FormControl;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private fb: FormBuilder,
              private stockService: StockService, private fileService: FileService) {

    super(sessionActions, cd);

    this.actions = [
      {
        label: 'Verschieben',
        icon: 'fa-clone',
        action: () => this.moveStocks.apply(this),
        disabled: () => !this.canMoveStocks.apply(this),
        helpText: 'Die ausgewählten Bestände vom Quell-Lager in das Ziel-Lager verschieben',
        disabledText: 'Bitte wählen Sie zuerst die Bestände aus, die verschoben werden sollen und füllen Sie alle Pflicht-Angaben aus!'
      }
    ]

  }

  ngOnInit(): void {
    super.ngOnInit();
    this.searchTerm = this.fb.control(null);
  }


  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.cd.detectChanges();
  }

  public canMoveStocks(): boolean {
    return this.moveStocksList && this.moveStocksList.control.valid;
  }

  public moveStocks() {
    const form = this.moveStocksList.movedStocksList();
    const _data = form.data;
    const _auth_data = form.auth_data;
    const _generate_vouchers = form.generate_vouchers;
    const _rearrangement_data = {
      source_depot_cuid: form.source_depot_cuid,
      target_depot_cuid: form.target_depot_cuid,
      rearrangement_note: form.rearrangement_note
    };

    this.stockService.moveStocks(_data, _auth_data, _generate_vouchers, _rearrangement_data).toPromise()
      .then(res => {

        this.sessionActions.pushMessage("Bestände erfolgreich verschoben", MessageType.SUCCESS);

        const pdfWithdrawal = res.data.moveStocks.voucher_withdrawal;
        const pdfWarehousing = res.data.moveStocks.voucher_warehousing;

        if (pdfWithdrawal) {
          let data = this.fileService.base64toBlob(pdfWithdrawal, 'application/pdf', 512);
          this.fileService.saveAs(data, 'warenausgangsbeleg.pdf');
        }

        if (pdfWarehousing) {
          let data = this.fileService.base64toBlob(pdfWarehousing, 'application/pdf', 512);
          this.fileService.saveAs(data, 'wareneingangsbeleg.pdf');
        }

        this.resetComponent();


      })
      .catch(err => this.sessionActions.throwError(err));
  }


  resetComponent(): void {
    super.resetComponent();
    this.searchTerm.reset();
  }
}



// WEBPACK FOOTER //
// ./src/app/store-management/stock/views/move-stocks-view/move-stocks-view.component.ts